import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slice/Authslice';
import appReducer from './slice/AppSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        app: appReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: [
                    'auth/setUser',
                    'app/openModal',  // Add this
                ],
                // Ignore these field paths in all actions
                ignoredActionPaths: [
                    'payload.user',
                    'payload.Children',  // Add this - for React components
                    'payload.Childern',  // Add this too in case of typo
                ],
                // Ignore these paths in the state
                ignoredPaths: [
                    'auth.user',
                    'app.modalState.Children',  // Add this
                ],
            },
        }),
});

export default store;